(function () {
    'use strict';

    angular.module("imApp").factory("consignmentsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 831,
                    parameters: parms || {}
                });
            },
            getBusinessChanged: function (setting) {
                return $ihttp.post({
                    method: 1090,
                    parameters: setting
                });
            },
            getStockPlaceChanged: function (setting) {
                return $ihttp.post({
                    method: 1094,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
